import { render, staticRenderFns } from "./flag-icon.vue?vue&type=template&id=28160250&scoped=true"
import script from "./flag-icon.ts?vue&type=script&lang=ts&external"
export * from "./flag-icon.ts?vue&type=script&lang=ts&external"
import style0 from "./flag-icon.less?vue&type=style&index=0&id=28160250&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28160250",
  null
  
)

export default component.exports